module.exports = __webpack_public_path__ + "static/img/mini3.98d2a029.png";